module.exports = __webpack_public_path__ + "static/03-a76a3e257b029dcc9ce5d07020c5125e.jpg";